<template>
  <div>
    <div class="feature-top">
      <product-feature-summary
        :imagePath="'/static/products/remote-reply-call-pc/feature/summary.jpg'"
        :altText="`長距離通信リモートリプライコールPC`"
        :headerText="
          `長距離通信システム「リモートリプライコール」を、
          PC 画面のマウス / タッチパネルで簡単に操作することができます！`
        "
        :detailText="
          `32 文字のメッセージを送信できる長距離通信システム「リモートリプライコール」を、PC 画面のマウス / タッチパネルで操作することが
          できます。 呼出しは、登録メッセージをマウスで選択し受信機番号を入力しコールボタンをクリックするだけでとても簡単。
          受信機の呼び出し状況は、ひと目で確認できるのわかりやすいアイコン表示で、お知らせ漏れの心配もありません。
          リモートリプライコール PC は、簡単操作で誰でも安心して使いこなしていただけるシステムです。`
        "
        :color="'green'"
      />

      <div class="feature-content">
        <content-header
          title="マウス / タッチパネルの簡単操作で受信機をメッセージで呼び出し"
          withBorder="true"
          fontColor="black"
          borderColor="green"
        />
        <div :style="this.$isPC ? '' : 'width: 70%;'">
          <p>
            送信機と Windows PC を
            USB接続することにより、マウス操作やタッチパネル操作での
          </p>
          <p>
            登録メッセージの送信が可能。従来のリプライコールを上回る高機能 &
            高操作性を実現しています。
          </p>
          <p>※ Windows10 を搭載する PC ならびにタブレットに対応</p>
        </div>
        <img
          v-lazy="
            '/static/products/remote-reply-call-pc/feature/feature_01.png'
          "
          style="top: -20px; width: 25%; height: auto;"
          :style="this.$isPC ? '' : 'top: 120px;'"
        />
      </div>

      <div class="feature-content">
        <content-header
          title="受信機は最大 999 台まで対応。 32 文字 (256 通り ) のメッセージを登録可能"
          withBorder="true"
          fontColor="black"
          borderColor="green"
        />
        <div :style="this.$isPC ? '' : 'width: 70%;'">
          <p>
            1 台の送信機が対応可能な受信機は最大 999
            台。業務の可能性を大きく拡げるパワフル設計です。
          </p>
          <p>
            また、PC 側で 256
            通りの登録メッセージの管理に対応。受信機へ簡単操作でメッセージを送信できます。
          </p>
          <p>
            メッセージは全角文字で最大 32
            文字まで登録可能。専用アプリでオリジナルメッセージを作成できます。
          </p>
        </div>
        <img
          v-lazy="
            '/static/products/remote-reply-call-pc/feature/feature_02.png'
          "
          style="top: 30px; width: 20%; height: auto;"
          :style="this.$isPC ? '' : 'width: 25%; top: 120px;'"
        />
      </div>

      <div class="feature-content">
        <content-header
          title="呼出状況は画面にアイコン表示。お知らせモレの心配なし"
          withBorder="true"
          fontColor="black"
          borderColor="green"
        />
        <div :style="this.$isPC ? '' : 'width: 70%;'">
          <p>
            送信した登録メッセージが受信機に届いたかどうかや、受信者が受信を確認したかどうかを、
          </p>
          <p>
            呼出状況画面のわかりやすいアイコン表示によりひと目で確認できます。
          </p>
          <p>
            呼び出しエラーの場合も再送ボタンで簡単再送、業務をスムーズに進行できます。
          </p>
        </div>
        <img
          v-lazy="
            '/static/products/remote-reply-call-pc/feature/feature_03.png'
          "
          style="top: 0px; width: 25%; height: auto;"
          :style="this.$isPC ? '' : 'top: 90px;'"
        />
      </div>

      <div class="appeal-block" v-if="this.$isPC">
        <h4 class="appeal-title">
          ひと目で確認できる！わかりやすいアイコン表示
        </h4>
        <div class="appeal-detail">
          <img
            v-lazy="
              '/static/products/remote-reply-call-pc/feature/feature_04.png'
            "
            style="width: 100%"
          />
        </div>
      </div>

      <div class="feature-content">
        <content-header
          title="受信機に呼び出しメッセージを表示。 お客様を確実に誘導します"
          withBorder="true"
          fontColor="black"
          borderColor="green"
        />
        <div :style="this.$isPC ? '' : 'width: 70%;'">
          <p>
            呼び出しを受けると、受信機の表示窓にメッセージを表示。遠くにいるお客様も確実に誘導・案内できます。
          </p>
          <p>
            また、受信機は呼び出しを受けると、ブザー音・バイブレーション・文字情報でお知らせ。
          </p>
          <p>呼び出しを見逃す心配がありません。</p>
        </div>
        <img
          v-lazy="
            '/static/products/remote-reply-call-pc/feature/feature_05.png'
          "
          style="top: -10px; width: 10%; height: auto;"
          :style="this.$isPC ? 'right: 10%' : 'width: 25%; top: 90px;'"
        />
      </div>
    </div>

    <div class="feature-section" v-if="this.$isPC">
      <div class="circle-parent">
        <div class="circle-heading green">
          <h2 class="circle-heading-title">操作の流れ</h2>
        </div>
      </div>

      <div class="operation-flow">
        <div class="header">
          <h3>
            かんたん操作で、パソコンからお客様をお呼び出し。
          </h3>
          <p>
            簡単操作でお客様をお呼び出し。
            呼出したい受信機ごとにメッセージを切り替えられるので、お客様を確実に誘導できます。
          </p>
        </div>
        <div class="body">
          <div class="operation-empty" />

          <div class="operation-block">
            <img
              v-lazy="
                '/static/products/remote-reply-call-pc/feature/operation_01.png'
              "
            />
            <div class="operation-block-title">
              1. 受信機を配布
            </div>
            <p>
              設定された受信機番号をご確認のうえ、呼び出したい方へ受信機をお渡しください。
            </p>
          </div>

          <div class="operation-arrow" />

          <div class="operation-block">
            <img
              v-lazy="
                '/static/products/remote-reply-call-pc/feature/operation_02.png'
              "
            />
            <div class="operation-block-title">
              2. 呼び出し
            </div>
            <p>
              <span style="color: red">❶</span> あらかじめ登録しておいた<br />
              &nbsp;&nbsp;&nbsp;&nbsp;送信メッセージを選択
            </p>
            <p><span style="color: red">❷</span> 受信機番号を入力</p>
            <p><span style="color: red">❸</span> コールボタンをクリック</p>
          </div>

          <div class="operation-arrow" />

          <div class="operation-block">
            <img
              v-lazy="
                '/static/products/remote-reply-call-pc/feature/operation_03.png'
              "
            />
            <div class="operation-block-title">
              3. 呼び出し確認
            </div>
            <p>
              呼び出したコールは、その都度画面の「呼出状況」に表示されます。
            </p>
            <p>
              呼出時間、メッセージ内容、受信機番号、現在の状態などがひと目で確認できます。
            </p>
          </div>

          <div class="operation-arrow" />

          <div class="operation-arrow" />

          <div class="operation-block">
            <img
              v-lazy="
                '/static/products/remote-reply-call-pc/feature/operation_04.png'
              "
            />
            <div class="operation-block-title">
              4. 呼び出し受信
            </div>
            <p>
              受信機は呼び出しを受けると、ブザーとバイブレーション、文字情報でお知らせします。
            </p>
          </div>

          <div class="operation-arrow" />

          <div class="operation-block">
            <img
              v-lazy="
                '/static/products/remote-reply-call-pc/feature/operation_05.png'
              "
            />
            <div class="operation-block-title">
              5. メッセージ表示
            </div>
            <p>
              受信機の確認ボタンを押せば、ブザー音・バイブレーションが止まり、文字情報が表示されます。
            </p>
          </div>

          <div class="operation-arrow" />

          <div class="operation-block">
            <img
              v-lazy="
                '/static/products/remote-reply-call-pc/feature/operation_06.png'
              "
            />
            <div class="operation-block-title">
              6. 画面で通信状況をチェック
            </div>
            <p>
              受信機に信号が届いたかどうか、お客様がメッセージを確認したかどうかなど、アイコン表示でわかりやすくチェックできます。
            </p>
          </div>

          <div class="operation-empty" />
        </div>
      </div>
    </div>

    <div class="feature-section">
      <div class="circle-parent">
        <div class="circle-heading green">
          <h2 class="circle-heading-title">主な機能</h2>
        </div>
      </div>

      <div class="main-function">
        <div class="body">
          <div class="product-block">
            <div class="product-block-header">
              <h3 class="product-genre">送信機</h3>
              <div class="product-detail">
                <p>コンパクトな省スペース設計。</p>
                <p>最適メッセージを選び、受信機番号を</p>
                <p>入力し、送信ボタンを押すだけ。</p>
              </div>
            </div>
            <img
              class="product-image"
              v-lazy="
                '/static/products/remote-reply-call-pc/feature/function_01.png'
              "
            />
            <div class="function">
              <div class="function-title">
                マウス/タッチパネルの簡単操作で呼出
              </div>
              <div class="function-detail">
                登録メッセージをマウスで選択し、受信機番号を入力しコールボタンをクリックするだけ。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                32文字メッセージを送信
              </div>
              <div class="function-detail">
                受信機の画面に全角文字で32文字のメッセージを送ることができます。
                メッセージは最大256通りまで登録可能。<br />
                PCアプリで自由に作成できます。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                受信機は最大999台まで利用可
              </div>
              <div class="function-detail">
                送信機には複数の受信機を登録し呼び出せる機能が搭載されています。
                1台の送信機で最大999台の受信機を登録できます。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                受信状況は画面にアイコン表示
              </div>
              <div class="function-detail">
                呼出し状況画面の解りやすいアイコン表示で、ひと目で確認できますので、お知らせ漏れの心配はありません。
              </div>
            </div>
          </div>

          <div class="product-block">
            <div class="product-block-header">
              <h3 class="product-genre">受信機</h3>
              <div class="product-detail">
                <p>スマートフォンを思わせるデザイン。</p>
                <p>音、バイブ、文字で呼び出しを知らせ、</p>
                <p>文字情報でご案内。</p>
              </div>
            </div>
            <img
              class="product-image"
              v-lazy="
                '/static/products/remote-reply-call-pc/feature/function_02.png'
              "
            />
            <div class="function">
              <div class="function-title">
                音、バイブ、文字で呼び出し
              </div>
              <div class="function-detail">
                ブザー音・バイブレーション・画面表示で呼び出しをお知らせ。<br />
                本体の確認ボタンを押せば停止し、文字情報を表示します。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                送信機へ呼出状況を返信
              </div>
              <div class="function-detail">
                送信機からの呼び出し信号を受信した時、 確認ボタンを押した時<br />
                それぞれの状況を自動で送信機へ返信。送信側は、信号が届いて<br />
                いるかどうかを心配する必要はありません。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                圏外表示機能
              </div>
              <div class="function-detail">
                電波強度表示を搭載。また受信機が「圏外」に移動した場合には、<br />
                異常音とバイブレーション、圏外表示で知らせます。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                連続待受36時間
              </div>
              <div class="function-detail">
                フル充電時は連続待ち受け 36 時間のロングライフ設計。<br />
                バッテリー残量表示も搭載しており、安心してご利用いただけます。
              </div>
            </div>
          </div>

          <div class="appeal-block" style="text-align: left">
            <div class="appeal-title">
              アプリのカスタマイズにも対応。
            </div>
            <div class="appeal-detail">
              企業様の既存システムと連携させて、自動送信が可能なPC用アプリのカスタマイズも承っておりますので、お気軽にお問い合わせください。
            </div>
          </div>

          <div class="product-block">
            <div class="product-block-header">
              <h3 class="product-genre">中継機</h3>
              <div class="product-detail">
                <p>中継機を使えば、通信エリアは</p>
                <p>さらに拡大。</p>
                <p>2台まで増設可能。</p>
              </div>
            </div>
            <img
              class="product-image"
              v-lazy="
                '/static/products/remote-reply-call-pc/feature/function_04.png'
              "
            />
            <div class="function">
              <div class="function-title">
                信号の「死角」を無くす
              </div>
              <div class="function-detail">
                信号の到達距離を大幅に延長するとともに、<br />
                障害物による電波干渉など、通信トラブルを解消します。<br />
                中継機は2台まで増設することができます。<br />
                ※&nbsp;中継機間のホッピング（送信機→中継機1→中継機2→受信機）は<br />
                &nbsp;&nbsp;&nbsp;&nbsp;できません。
              </div>
            </div>
          </div>

          <div class="product-block">
            <div class="product-block-header">
              <h3 class="product-genre">充電器</h3>
              <div class="product-detail">
                <p>10台一度に充電可能。</p>
                <p>手入れもしやすい</p>
                <p>コンパクト設計。</p>
              </div>
            </div>
            <img
              class="product-image"
              v-lazy="
                '/static/products/remote-reply-call-pc/feature/function_05.png'
              "
            />
            <div class="function">
              <div class="function-title">
                急速充電5時間
              </div>
              <div class="function-detail">
                フル充電には約 5 時間。<br />
                充電状態も受信機の充電用 LED で確認できます。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                履歴クリア
              </div>
              <div class="function-detail">
                充電器にセットすれば、受信機の履歴は自動的に消去されます。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                「充電中」をアラーム表示
              </div>
              <div class="function-detail">
                充電中の受信機を呼び出すことはできません。<br />
                送信機には「充電中」と表示されます。
              </div>
            </div>
          </div>

          <div class="product-block"></div>
        </div>
      </div>
    </div>

    <div class="feature-section">
      <div class="circle-parent">
        <div class="circle-heading green">
          <h2 class="circle-heading-title">システム<br />構成例</h2>
        </div>
      </div>
      <div class="system-config">
        <img
          v-lazy="'/static/products/remote-reply-call-pc/feature/system.png'"
        />
      </div>
    </div>

    <div class="feature-section">
      <div class="circle-parent">
        <div class="circle-heading green">
          <h2 class="circle-heading-title">使用例</h2>
        </div>
      </div>
      <div class="header">
        <h3>
          呼出状況は画面のアイコン表示でお知らせ漏れの心配なし
        </h3>
      </div>
      <div>
        <img
          style="width: 100%;max-width: 850px;"
          src="/static/columns/50/img-dontnotice-receptionists-call3.png"
          alt="呼出状況は画面のアイコン表示でお知らせ漏れの心配なし"
        />
      </div>
      <div>
        <img
          style="width: 100%;max-width: 850px;"
          src="/static/columns/53/img-call-waiting-customer3-2.png"
          alt="リモートリプライコールPC"
        />
      </div>
      <p class="cta-microcopy" style="margin-top: 2.5rem">
        ＼この使い方にピンときた方へ／
      </p>
      <div
        class="column_wrap_cta"
        style="background: none; padding: 0; margin-bottom: 3.5rem"
      >
        <a class="column_wrap_cta_contact" href="/contact"
          >無料見積もり・お問い合わせはこちら</a
        >
      </div>
    </div>

    <div class="feature-section worry">
      <div class="circle-parent">
        <div class="circle-heading green">
          <h2 class="circle-heading-title">お悩み<br />コンテンツ</h2>
        </div>
      </div>
    </div>
    <div class="worries-column" style="margin-bottom: 6%;">
      <div class="use-scene-block">
        <router-link to="/column/47">
          <div class="use-scene-block-header">
            トラックバースの回転率が悪いときに効果的な呼び出しベルを紹介
          </div>
        </router-link>
        <p>
          トラックバースの回転率向上は、2024年問題への対策として重要です。音だけでなく、バイブレーションや光、メッセージで呼び出せる呼び出しベルを導入し、回転率を上げましょう。
        </p>
      </div>
      <div class="use-scene-block">
        <router-link to="/column/46">
          <div class="use-scene-block-header">
            ドライバーが長時間労働になっている物流業界向け呼び出しベルを紹介
          </div>
        </router-link>
        <p>
          2024年問題が深刻化する中で、荷待ち時間減少などの効率化は必須事項です。この記事では、ドライバーの労働時間を改善するために効果的な呼び出しベルについて紹介します。
        </p>
      </div>
      <div class="use-scene-block">
        <router-link to="/column/50">
          <div class="use-scene-block-header">
            受付の呼び出しに気付いてもらえないときは呼び出しベルがおすすめ
          </div>
        </router-link>
        <p>
          利用者が多い時間帯や特定の手続きが集中する時期には、市役所などの受付は混雑し、呼び出しに気づいてもらえない可能性が高くなります。混雑解消のためにも、呼び出しベルを導入し、受付の呼び出しに気づいてもらいましょう。
        </p>
      </div>
      <div class="use-scene-block">
        <router-link to="/column/53">
          <div class="use-scene-block-header">
            順番待ちのお客様を呼び出したいアミューズメント施設向きのツールとは
          </div>
        </router-link>
        <p>
          お客様がアミューズメント施設内の好きな場所で待てるようにしつつ、呼び出しやすくするためには呼び出しベルがおすすめです。アミューズメント施設向けの呼び出しベルを紹介します。
        </p>
      </div>
    </div>

    <div class="feature-section" id="spec">
      <div class="circle-parent">
        <div class="circle-heading green">
          <h2 class="circle-heading-title">仕様</h2>
        </div>
      </div>
      <div class="main-specification">
        <div class="specification-detail">
          <specs v-bind:useType="useType" v-bind:items="items" />
        </div>
      </div>
    </div>

    <div class="feature-section" id="price">
      <div class="circle-parent">
        <div class="circle-heading green">
          <h2 class="circle-heading-title">価格</h2>
        </div>
      </div>
      <div class="main-specification">
        <div class="specification-detail">
          <prices
            v-bind:items="
              items.filter(function(item) {
                return (
                  (item.listPrice > 0 && item.regularPrice > 0) ||
                  item.openPrice > 0 ||
                  item.summaryImagePath
                )
              })
            "
          />
        </div>
      </div>
    </div>

    <div class="feature-section" id="catalogue">
      <div class="circle-parent">
        <div class="circle-heading green">
          <h2 class="circle-heading-title">カタログ</h2>
        </div>
      </div>
      <div class="main-specification">
        <div class="specification-detail">
          <catalogues
            v-bind:useType="useType"
            v-bind:productName="productName"
            v-bind:items="catalogues"
          />
        </div>
      </div>
    </div>

    <div class="product_question">
      <h2 style="color: #0a518d">よくある質問</h2>
      <question-and-answer
        :number="1"
        :question="'既存システムと連携させて、自動で送信することは出来ますか？'"
        :answer="
          `専用アプリのカスタマイズ仕様で実現可能です。カスタマイズ仕様は特定のフォルダを常時監視し、呼び出し指示が連携ファイルが書き込まれたらファイル内のメッセージ番号、端末コードでメッセージを自動で送信します。`
        "
      />
      <question-and-answer
        :number="2"
        :question="'リモートリプライコールをＰＣで操作できますか？'"
        :answer="
          `リモートリプライコールをPC画面のマウス／タッチパネルの簡単操作で呼出しが可能です。登録メッセージをマウスで選択し、受信機番号を入力しコールボタンをクリックするだけ。呼び出し状況もわかりやすいアイコン表示で、お知らせ漏れの心配もありません。`
        "
      />
      <question-and-answer
        :number="3"
        :question="
          '受信機にメッセージが届いたか、お客様がメッセージを確認したかどうか確認できますか？'
        "
        :answer="
          `呼出状況画面のわかりやすいアイコン表示によりひと目で確認できます。呼び出しエラーの場合も再送ボタンで簡単再送、業務をスムーズに進行できます。`
        "
      />
    </div>

    <div class="column_nav">
      <h2 style="color: #0a518d">おすすめのコンテンツ</h2>
      <ul
        style="width: 100%; max-width: 960px; margin: 0 auto; box-sizing: border-box;"
      >
        <li>
          <a href="/choice/industry/6" target="_blank"
            ><img
              src="/static/columns/19/warehouse_mv.png"
              alt="物流倉庫の呼出しベルについて"
          /></a>

          <h3>
            <a href="/choice/industry/6" target="_blank"
              >物流倉庫の呼出しベルについて</a
            >
          </h3>
        </li>
        <li>
          <a href="/column/6" target="_blank"
            ><img
              src="/static/columns/6/img_logistics_operations1.jpg"
              alt="物流倉庫におけるオペレーションの効率化｜工程ごとにポイントを解説"
          /></a>

          <h3>
            <a href="/column/6" target="_blank"
              >物流倉庫におけるオペレーションの効率化｜工程ごとにポイントを解説</a
            >
          </h3>
        </li>
        <li>
          <a href="/column/7" target="_blank"
            ><img
              src="/static/columns/7/img_foodcourt_callbell_mechanism1.jpg"
              alt="フードコートの呼び出しベルの仕組みは？よくある疑問とおすすめ機種"
          /></a>

          <h3>
            <a href="/column/7" target="_blank"
              >フードコートの呼び出しベルの仕組みは？よくある疑問とおすすめ機種</a
            >
          </h3>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ProductFeatureSummary from '@/components/modules/ProductFeatureSummary'
import ContentHeader from '@/components/modules/ContentHeader'
import Specs from '@/components/modules/Specs'
import Prices from '@/components/modules/Prices'
import Catalogues from '@/components/modules/Catalogues'
import QuestionAndAnswer from '@/components/modules/QuestionAndAnswer'

export default {
  components: {
    ProductFeatureSummary,
    ContentHeader,
    Specs,
    Prices,
    Catalogues,
    QuestionAndAnswer,
  },
  data() {
    return {
      productName: 'remote-reply-call-pc',
      useType: 1,
      items: [
        {
          name: '送信機',
          imagePath: '/static/products/remote-reply-call-pc/items/item_01.png',
          spec: {
            型式: 'RR-100',
            サイズ: '214(W) × 151(D) × 43(H) mm',
            重量: '約 860g',
            電源: '100V DC6V アダプタ',
            周波数: '920.60 〜 923.40MHz',
            チャンネル: '15チャンネル（中継機使用時は5チャンネル）',
            空中線電力: '20mW 特定小電力',
          },
          priceName: `送信機
          白(RR-101W) or 黒(RR-101B)
          アプリ・インストーラー含む`,
          listPrice: 380000,
          regularPrice: 266000,
          comment: '※アプリ・インストーラー付',
        },
        {
          name: '受信機',
          imagePath: '/static/products/remote-reply-call-pc/items/item_02.png',
          spec: {
            型式: 'RR-200',
            サイズ: '60（W）×123（D）×13（H）mm',
            重量: '約 115g（電池パック含む）',
            電源: 'リチウムイオン電池 3.8V 1800mAh',
            周波数: '920.60~923.40MHz',
            チャンネル: '15 チャンネル（中継機使用時は 5 チャンネル）',
            連続待ち受け時間: '約 36 時間',
            充電時間: '約 5 時間',
            空中線電力: '20mW 特定小電力',
          },
          priceName: `受信機
          白(RR-200W) or 黒(RR-200B)`,
          listPrice: 65000,
          regularPrice: 45500,
        },
        {
          name: '充電器',
          imagePath: '/static/products/remote-reply-call-pc/items/item_04.png',
          spec: {
            型式: 'RR-300',
            サイズ: '80（W）×305（D）×61（H）mm',
            重量: '約 530g',
            電源: '100V DC6V アダプタ',
            方式: '接点充電',
          },
          priceName: `充電器 10台タイプ（RR-300）`,
          listPrice: 45000,
          regularPrice: 31500,
        },
        {
          name: '中継機',
          imagePath: '/static/products/remote-reply-call-pc/items/item_03.png',
          spec: {
            型式: 'RR-400',
            サイズ: '224.5（W）×177（D）×28（H）mm',
            重量: '約 285g',
            電源: '100V DC6V アダプタ',
            周波数: '920.60~923.40MHz',
            チャンネル: '5 チャンネル',
            空中線電力: '20mW 特定小電力',
          },
          priceName: `中継機（RR-400）`,
          listPrice: 150000,
          regularPrice: 105000,
        },
      ],
      catalogues: [
        {
          id: 1,
          name: 'リモートリプライコールPC',
          imagePath:
            '/static/products/remote-reply-call-pc/catalogues/catalogue_01.png',
          downloadUri:
            '/static/products/remote-reply-call-pc/catalogues/catalogue_01.pdf',
          pageCount: 2,
          fileType: 'PDF',
          fileSize: '約2.0MB',
        },
        {
          id: 2,
          name: 'リモートリプライコールPC 取り扱い説明書',
          imagePath:
            '/static/products/remote-reply-call-pc/catalogues/catalogue_02.png',
          downloadUri:
            '/static/products/remote-reply-call-pc/catalogues/catalogue_02.pdf',
          pageCount: 12,
          fileType: 'PDF',
          fileSize: '約885KB',
        },
      ],
    }
  },
}
</script>

<style scoped>
.appeal-block {
  margin: 15px 0 50px;
  padding: 25px 40px;

  border: 1px solid rgb(73, 195, 108);
  border-radius: 10px;
  background-color: white;
}

.appeal-block .appeal-title {
  font-size: 20px;
  font-weight: bold;

  margin-top: 0;
  margin-bottom: 15px;

  color: rgb(45, 183, 68);
}

.appeal-block .appeal-detail {
  font-size: 14px;

  display: inline-block;

  vertical-align: middle;
}

.feature-section .use-scene {
  background-color: rgb(218, 243, 225);
}

.feature-section .header h3 {
  color: rgb(45, 183, 68);
  font-size: 1.5em;
}

.feature-section .use-scene .body {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  max-width: 960px;
  margin: 0 auto;
}

.feature-section .use-scene .body .use-scene-block {
  align-self: flex-start;

  width: 420px;
  margin: 20px 15px;

  text-align: left;
}

.feature-section .use-scene .body .use-scene-block img {
  display: block;

  width: 100%;
  max-width: 420px;
  height: auto;
  margin: 10px auto;

  background-color: #eee;
}

.feature-section .use-scene .body .use-scene-block p {
  font-size: 12px;
  line-height: 22px;

  margin: 0;
}

.feature-section .use-scene .body .use-scene-block .use-scene-block-header {
  font-size: 18px;
  font-weight: bold;

  padding-left: 10px;

  border-left: 4px solid rgb(45, 183, 68);
}

.feature-section .operation-flow {
  width: 900px;
  margin: 0 auto;

  border-radius: 5px;
  background-color: rgb(218, 243, 225);
}

.feature-section .operation-flow .header span {
  display: inline-block;

  width: 450px;

  text-align: left;
}

.feature-section .operation-flow .header img {
  display: inline-block;

  width: 350px;
  height: auto;
}

.feature-section .operation-flow .border {
  margin: 0 40px;

  border-bottom: 1px solid white;
}

.feature-section .operation-flow .body {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  margin: 20px 0;
}

.feature-section .operation-flow .body .operation-block {
  align-self: flex-start;

  width: 220px;
  margin-bottom: 30px;

  text-align: left;
}

.feature-section .operation-flow .body .operation-block img {
  width: auto;
  height: 130px;
}

.feature-section .operation-flow .body .operation-block .operation-block-title {
  font-weight: bold;
  line-height: 20px;

  margin: 5px 0 10px;
}

.feature-section .operation-flow .body .operation-block p {
  font-size: 13px;

  margin: 0;
}

.feature-section .operation-flow .body .operation-arrow {
  width: 0;
  height: 0;
  margin: 52.5px 20px;

  border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;
  border-left: 15px solid rgb(125, 212, 141);
}

.feature-section .operation-flow .body .operation-empty {
  width: 55px;
}

.feature-section .system-config {
  background: linear-gradient(rgb(228, 236, 243), white);
}

.feature-section .system-config img {
  width: 90%;
  max-width: 1100px;
  padding: 120px 0 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/products/features/RemoteReplyCallPc.vue